<template>
  <i :class="'fa fa-' + name + ' ' + tamanyo"></i>
</template>
<script>
  export default {
    name: 'donIcon',
    props:
    {
      name: '', tamanyo: ''
    }
  }
</script>



// WEBPACK FOOTER //
// src/componentes/global/don.icon.vue